import { Component, OnInit } from '@angular/core';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';
import { Textbox } from '../../models/editors/textbox.model';

@Component({
  selector: 'swb-contacts-map',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class ContactsmapComponent extends InlineFormBase<{ address: string }> implements OnInit {
  public url = 'maps';
  public headerTitle = 'Mapa';
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'address',
        label: 'Adresa Google Map'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
